import * as SimstreamConstants from './constants';
import * as D from './deps';
import PlaybackIntercept from './middleware';
import SimStreamReducer from './reducer';
import SimStreamWatchers from './sagas/watchers';
import externalUtils from './utils';

export default D.createDomainModule({
  name: SimstreamConstants.DOMAIN_NAME,
  components: {},
  utils: externalUtils,
  reducer: SimStreamReducer,
  middleware: PlaybackIntercept(history),
  onStart() {
    this.registeredHandlers = D.registerHandlers(SimStreamWatchers);
  },
  onStop() {
    D.removeAndStopHandlers(this.registeredHandlers, this.name);
  },
});
